/* eslint-disable jsx-a11y/click-events-have-key-events */

import PropTypes from 'prop-types';
import React from 'react';
import { Chevron } from '@surfline/quiver-react';
import { slugify } from '@surfline/web-common';
import {
  subregionForecastPath,
  subregionPremiumAnalysisPath,
} from '@surfline/web-common/dist/paths/kbyg';
import nearbySubregionsPropType from '../../propTypes/nearbySubregions';
import en from '../../intl/translations/en';
import subregionForecastChartsPath from '../../utils/urls/subregionForecastChartsPath';

const linkTo = (subregionSlug, subregionId, subregionName, pathName) => {
  if (pathName.indexOf('surf-charts') !== -1) {
    return `${subregionForecastChartsPath(subregionId, 'wave-height', subregionName)}`;
  }
  if (pathName.indexOf('premium-analysis') !== -1) {
    return subregionPremiumAnalysisPath(subregionSlug, subregionId);
  }
  return subregionForecastPath(subregionSlug, subregionId);
};

const NearbySubregions = ({
  className,
  title,
  nearbySubregions,
  chevronDirection,
  pathName,
  onClickLink,
  onClick,
}) => (
  <div className={className} onClick={onClick}>
    <div className="sl-forecast-header-menu__dropdown__title">
      {title} <Chevron direction={chevronDirection} />
    </div>
    <div className="sl-forecast-header-menu__nearby-subregions">
      {nearbySubregions.map(subregion => (
        <a
          key={subregion._id}
          title={`${subregion.name} ${en.RegionalForecast.header.titleSuffix}`}
          className="sl-forecast-header-menu__nearby-subregion"
          href={linkTo(slugify(subregion.name), subregion._id, subregion.name, pathName)}
          onClick={() => onClickLink(subregion)}
        >
          <span className="sl-forecast-header-menu__nearby-subregion__details__name">
            {subregion.name}
          </span>
        </a>
      ))}
    </div>
  </div>
);

NearbySubregions.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  nearbySubregions: nearbySubregionsPropType.isRequired,
  chevronDirection: PropTypes.oneOf(['down', 'up']).isRequired,
  pathName: PropTypes.string,
  onClickLink: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

NearbySubregions.defaultProps = {
  className: null,
  pathName: null,
};

export default NearbySubregions;
